import React from "react";
import "./Footer.css"

const Footer = () => {
  return (
    <>
    <div className="footer">
      <p className="footer-text">
        Dea Bankova & 藤原寛奈　 
      </p>
      <div className="footer-pigeon"></div>
    </div>  
    </>
  )
};

export default Footer;